<template>
   <div id="restaurant-menu">
    <div class="container">

      <div class="section-title text-center">
        <h2>{{msg}}</h2>
      </div>

      <div class="row">
        <div class="col-xs-12 col-sm-6" v-for="item in menuSection" :key="item.title">
          <div class="menu-section">
            <h2 class="menu-section-title">{{item.title}}</h2>
            <div class="menu-item" v-for="i in item.menuItems" :key="i.price">
              <div class="menu-item-name">{{i.name}}</div>
              <div class="menu-item-price"> {{i.price}} </div>
              <div class="menu-item-description"> {{i.text}} </div>
            </div>           
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MenuComponent',
  data : function () {
    return {
      msg : 'menu',
      menuSection :[
        {
          title:'Breakfast & Starters',
          menuItems: [
            {
              name: "Tortellini Skewers",
              price: "$9",
              text:
                " Lorem ipsum dolor sit amet, consectetur adipiscing elit, duis sed dapibus leo nec ornare diam."
            },
            {
              name: "Fried Ravioli",
              price: "$7",
              text:
                " Lorem ipsum dolor sit amet, consectetur adipiscing elit, duis sed dapibus leo nec ornare diam."
            },
            {
              name: "Wild Mushroom Arancini",
              price: "$10",
              text:
                " Lorem ipsum dolor sit amet, consectetur adipiscing elit, duis sed dapibus leo nec ornare diam."
            },
            {
              name: "Mozzarella Sticks",
              price: "$11",
              text:
                " Lorem ipsum dolor sit amet, consectetur adipiscing elit, duis sed dapibus leo nec ornare diam."
            }
          ]
        },
        {
          title:'main course',
          menuItems: [
            {
              name: "Roast Stuffed Chicken",
              price: "$9",
              text:
                " Lorem ipsum dolor sit amet, consectetur adipiscing elit, duis sed dapibus leo nec ornare diam."
            },
            {
              name: "Fried Ravioli",
              price: "$7",
              text:
                " Lorem ipsum dolor sit amet, consectetur adipiscing elit, duis sed dapibus leo nec ornare diam."
            },
            {
              name: "Wild Mushroom Arancini",
              price: "$10",
              text:
                " Lorem ipsum dolor sit amet, consectetur adipiscing elit, duis sed dapibus leo nec ornare diam."
            },
            {
              name: "Mozzarella Sticks",
              price: "$11",
              text:
                " Lorem ipsum dolor sit amet, consectetur adipiscing elit, duis sed dapibus leo nec ornare diam."
            }
          ]
        },
        {
          title:'dinner',
          menuItems: [
            {
              name: "Roast Stuffed Chicken",
              price: "$9",
              text:
                " Lorem ipsum dolor sit amet, consectetur adipiscing elit, duis sed dapibus leo nec ornare diam."
            },
            {
              name: "Fried Ravioli",
              price: "$7",
              text:
                " Lorem ipsum dolor sit amet, consectetur adipiscing elit, duis sed dapibus leo nec ornare diam."
            },
            {
              name: "Wild Mushroom Arancini",
              price: "$10",
              text:
                " Lorem ipsum dolor sit amet, consectetur adipiscing elit, duis sed dapibus leo nec ornare diam."
            },
            {
              name: "Mozzarella Sticks",
              price: "$11",
              text:
                " Lorem ipsum dolor sit amet, consectetur adipiscing elit, duis sed dapibus leo nec ornare diam."
            }
          ]
        },
        {
          title:'desserts',
          menuItems: [
            {
              name: "Roast Stuffed Chicken",
              price: "$9",
              text:
                " Lorem ipsum dolor sit amet, consectetur adipiscing elit, duis sed dapibus leo nec ornare diam."
            },
            {
              name: "Fried Ravioli",
              price: "$7",
              text:
                " Lorem ipsum dolor sit amet, consectetur adipiscing elit, duis sed dapibus leo nec ornare diam."
            },
            {
              name: "Wild Mushroom Arancini",
              price: "$10",
              text:
                " Lorem ipsum dolor sit amet, consectetur adipiscing elit, duis sed dapibus leo nec ornare diam."
            },
            {
              name: "Mozzarella Sticks",
              price: "$11",
              text:
                " Lorem ipsum dolor sit amet, consectetur adipiscing elit, duis sed dapibus leo nec ornare diam."
            }
          ]
        }
      ]
    }
  } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#restaurant-menu {
	padding: 60px 0;
}
#restaurant-menu img {
	width: 300px;
	box-shadow: 15px 0 #a7c44c;
}
#restaurant-menu h3 {
	padding: 10px 0;
	text-transform: uppercase;
   text-align: left;
}
#restaurant-menu .menu-section hr {
	margin: 0 auto;
}
#restaurant-menu .menu-section {
	margin: 0 20px 80px;
}
#restaurant-menu .menu-section-title {
	font-size: 32px;
	display: block;
	font-weight: 400;
	color: #444;
	margin: 20px 0;
}
#restaurant-menu .menu-item {
	margin: 45px 0;
	font-size: 18px;
}
#restaurant-menu .menu-item-name {
	font-weight: 400;
	font-size: 20px;
	color: #444;
	margin-bottom: 10px;
   text-align: left;
}
#restaurant-menu .menu-item-description {
	font-size: 15px;
	width: 85%;
   text-align: left;
}
#restaurant-menu .menu-item-price {
	float: right;
	font-weight: 400;
	color: #555;
	margin-top: -36px;
}
</style>
